import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ContractType } from "./contract-type.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserService } from "src/app/shared/user.service";

@Injectable({
  providedIn: "root",
})
export class ContractTypeService {
  private messageSource = new BehaviorSubject("");
  currentMessage = this.messageSource.asObservable();
  ContractTypeList: ContractType[];
  contracttypeBaseUrl: String;
  ContractType: ContractType;

  AttributeList = [];
  constructor(private http: HttpClient, public userService: UserService) {
    this.contracttypeBaseUrl = environment.contractTypeApiURL;
  }
  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  getContractList(all = false) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/ContractType?tenantId=" +
          this.userService.loggedinUser.tenantId
        )
        .toPromise()
        .then((res: ContractType[]) => {
          let filteredData = res;
          if(!all)
            filteredData = res.filter((type: ContractType) => type.status == 'Approved');
          resolve(filteredData);
        })

    });
  }
  getAttributeList() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/SeedAttribute"
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error)
        })

    });
  }
  saveContract(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    data.tenantId = this.userService.loggedinUser.tenantId;
    data.createdDate = new Date();
    data.updatedDate = new Date();
    data.createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    data.updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    data.contractTypeId = 0;
    data.contractTypeStatusId = 1;
    if (data.attributes.length > 0) {
      delete data.attributes[0].attributeId;
      data.attributes[0].tenantId =
        this.userService.loggedinUser.tenantId;
      data.attributes[0].updatedDate = new Date();
      data.attributes[0].updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
      data.attributes[0].createdDate = new Date();
      data.attributes[0].createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    }
    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.contracttypeBaseUrl + "/ContractType",
          data,
          httpOptions
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }


  saveAttribute(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    data.tenantId = this.userService.loggedinUser.tenantId;
    data.createdDate = new Date();
    data.updatedDate = new Date();
    data.createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    data.updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    delete data.attributeId;

    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.contracttypeBaseUrl + "/SeedAttribute",
          data,
          httpOptions
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  activateContract(contractType, seedAttributes) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    contractType.contractTypeStatusId = 3;
    seedAttributes.forEach(item => {
      item.tenantId = this.userService.loggedinUser.tenantId;
      item.contractTypeId = contractType.contractTypeId;
    });
    contractType.attributes = seedAttributes;

    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.contracttypeBaseUrl + "/ContractType",
          contractType,
          httpOptions
        )
        .toPromise().then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  editContract(data, contractType) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    data.tenantId = this.userService.loggedinUser.tenantId;
    data.createdDate = new Date();
    data.updatedDate = new Date();
    data.createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    data.contractTypeId = contractType.contractTypeId;
    data.contractTypeStatusId = contractType.contractTypeStatusId;
    data.updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    if (data.attributes.length > 0) {
      if (data.attributes[0].attributeId == null) {
        data.attributes[0].attributeId = 0;
      }
      data.attributes[0].tenantId = this.userService.loggedinUser.tenantId;
      data.attributes[0].updatedDate = new Date();
      data.attributes[0].updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
      data.attributes[0].createdDate = new Date();
      data.attributes[0].createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
      data.attributes[0].contractTypeId = contractType.contractTypeId;
    }

    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.contracttypeBaseUrl + "/ContractType",
          data,
          httpOptions
        )
        .toPromise().then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getAttributeMetadataType() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.contracttypeBaseUrl + "/ContractType/MetaDataType")
        .toPromise()
        .then((res) => {
          resolve(res);
        });
    });
  }

  deleteSeedAttribute(seedAttributeId: number) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          this.contracttypeBaseUrl +
          `/SeedAttribute/${seedAttributeId}`
        )
        .toPromise()
        .then((res: any) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  deleteAttribute(attributeId: number, contractTypeId: any) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          this.contracttypeBaseUrl +
          `/ContractType/DeleteContractTypeAttribute/${parseInt(contractTypeId)}/${this.userService.loggedinUser.tenantId}/${attributeId}`,
        )
        .toPromise()
        .then((res: any) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  getAContract(id: number) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/ContractType/" +
          id +
          "?tenantId=" +
          this.userService.loggedinUser.tenantId
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        });
    });
  }

  activateContractType() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return new Promise<void>((resolve, reject) => {
      this.http
        .put(
          this.contracttypeBaseUrl +
          "/ContractType/ContractTypeStatus?tenantId=" +
          this.userService.loggedinUser.tenantId,
          { contractTypeId: this.ContractType.contractTypeId },
          httpOptions
        )
        .toPromise()
        .then((res) => {
          resolve();
        });
    });
  }

  updateSeedAttribute(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    data.updatedDate = new Date();
    data.updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    data.createdDate = new Date();
    data.createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
    return new Promise<void>((resolve, reject) => {
      this.http
        .put(
          this.contracttypeBaseUrl +
          "/SeedAttribute",
          data,
          httpOptions
        )
        .toPromise()
        .then((res: any) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
}
